var map = {
	"./InsightsDashboard.png": "./src/assets/images/track/InsightsDashboard.png",
	"./appmDashboard.png": "./src/assets/images/track/appmDashboard.png",
	"./cluster.png": "./src/assets/images/track/cluster.png",
	"./dataQuality.png": "./src/assets/images/track/dataQuality.png",
	"./home.png": "./src/assets/images/track/home.png",
	"./how_to_contact.png": "./src/assets/images/track/how_to_contact.png",
	"./inquisight.png": "./src/assets/images/track/inquisight.png",
	"./interact_with_widgets.png": "./src/assets/images/track/interact_with_widgets.png",
	"./setup.png": "./src/assets/images/track/setup.png",
	"./started.png": "./src/assets/images/track/started.png",
	"./storyBoard.png": "./src/assets/images/track/storyBoard.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/track sync recursive ^\\.\\/.*$";